import script from "./FeeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeeModal.vue?vue&type=script&setup=true&lang=ts"

import "./FeeModal.vue?vue&type=style&index=0&id=401573e4&lang=scss&scoped=true"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-401573e4"]])

export default __exports__